import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../LanguageSelector';
import { Helmet } from 'react-helmet-async';
import Logotype from './Components/logotype/Logotype';
import config from '../../config/config';
import sendityLogo from '../../themed/images/sendity-group.svg';
import useIsMobile from '../../hooks/mobile';
import RegisterSimpleStep from './Components/registerSimpleStep/RegisterSimpleStep';
import RegisterStep from './Components/registerStep/RegisterStep';
import RegisterRevolupayStep from './Components/registerRevolupayStep/RegisterRevolupayStep';
import RevolupayStep from './Components/revolupaySteps/revolupaySteps';
import LoadButton from '../loadButton/LoadButton';
import ArrowBack from '../back/ArrowBack';
import CrossBack from '../back/CrossBack';
import './layout.css';
function LayoutNoStepLeft(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <>
      {config.NOINDEX ? (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      ) : (
        ''
      )}
      <div className="p-0">
        <LanguageSelector prefix={'select_language_mobile_hidden'} />

        <main>
          <div className="container-fluid m-0 p-0">
            <div className="wrapper_layout-register noLeft">
              <div className="row g-0">
                {!isMobile && props.logoStep && <Logotype />}
                {props.simpleStep && <RegisterSimpleStep activeStep={props.activeStep} />}
                {!isMobile && props.revolupayStep && (
                  <RegisterRevolupayStep activeStep={props.activeStep} />
                )}
                {!isMobile && props.step && (
                  <RegisterStep
                    route={props.route}
                    activeStep={props.activeStep}
                    step={props.step}
                    routeName={props.routeName}
                  />
                )}
                {!isMobile && props.revStep && <RevolupayStep activeStep={props.activeStep} />}

                <div className={`col-md-7 nostep_sec_right ${props.classSecR}`}>
                  {props.logo && (
                    <img
                      src={sendityLogo}
                      alt="logo sendity"
                      onClick={() => navigate('/')}
                      className="d-inline d-md-none"
                    />
                  )}

                  {props.returnArrow && !props.returnCross && !props.returnRevolupey && (
                    <div
                      className={`back-layout justify-content-${
                        props.backDirection ? props.backDirection : 'end'
                      }`}
                    >
                      <ArrowBack />{' '}
                    </div>
                  )}
                  {props.returnCross && !props.returnArrow && !props.returnRevolupey && (
                    <div
                      className={`back-layout justify-content-${
                        props.backDirection ? props.backDirection : 'end'
                      }`}
                    >
                      <CrossBack />
                    </div>
                  )}
                  {props.returnCross && props.returnArrow && !props.returnRevolupey && (
                    <div className={`back-layout justify-content-between`}>
                      <ArrowBack /> <CrossBack />
                    </div>
                  )}
                  {props.returnRevolupey && !props.returnArrow && !props.returnCross && (
                    <div
                      onClick={() => {
                        if (props.returnRev) props.returnRev();
                        navigate('/');
                      }}
                      className={`return-revolupey font-s text-${
                        props.backDirection ? props.backDirection : 'end'
                      }`}
                    >
                      {t('Volver al menú principal')}
                    </div>
                  )}
                  {props.returnRevolupey && (props.returnArrow || props.returnCross) && (
                    <div className={`back-layout justify-content-between`}>
                      {props.returnCross && <CrossBack />}
                      {props.returnArrow && <ArrowBack />}
                      <div
                        onClick={async () => {
                          if (props.returnRev) await props.returnRev();
                          navigate('/');
                        }}
                        className={`font-s text-${
                          props.backDirection ? props.backDirection : 'end'
                        }`}
                      >
                        {t('Volver al menú principal')}
                      </div>
                    </div>
                  )}
                  {props.children}
                </div>
                <div className={!props.sendPack ? `d-none` : ''}>
                  <div className={`col-md-5 left-footer-list`}></div>
                  <div className={``}>
                    <div className="col-12 col-md-7 footer_list_tariff ">
                      <LoadButton
                        text="Enviar recarga"
                        disabled={!props.selectedPack ? true : false}
                        onClick={props.sendPack}
                        classNameButtom={!props.selectedPack ? 'bc-greyone' : ''}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
export default LayoutNoStepLeft;
